import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import { CircularProgress, IconButton, Link } from '@mui/material';
import Stack from '@mui/material/Stack';
import CloseIcon from '@mui/icons-material/Close';

import { responsiveBreakpoints } from 'utils/utils';
import { useTopNotification } from './top-notification-hook';

const TopNotification = ({
  notificationId,
  startIcon,
  message,
  linkName,
  linkUrl,
}) => {
  const { mainWidth, mobile } = responsiveBreakpoints();
  const { updateNotificationStatus, isNotificationLoading } =
    useTopNotification({ notificationId });

  return (
    <Stack
      sx={{
        minHeight: '40px',
        backgroundColor: '#0075FD',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px 0px',
        borderRadius: '4px',
      }}
    >
      <Stack
        direction='row'
        sx={{
          width: mainWidth,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: mobile ? '0px 8px' : '0px 50px',
        }}
      >
        <Stack
          spacing={1}
          direction='row'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: 1,
            color: '#FFFFFF',
          }}
        >
          {startIcon ? (
            <IconButton sx={{ color: '#FFFFFF' }}>
              <img src={startIcon} />
            </IconButton>
          ) : null}

          <Typography
            variant='h4'
            sx={{
              fontWeight: 300,
              color: '#FFFFFF',
            }}
          >
            {message}
          </Typography>
          {linkUrl ? (
            <Link
              sx={{ color: 'inherit', textDecorationColor: 'inherit' }}
              href={linkUrl}
              target='_blank'
              rel='noopener noreferrer'
            >
              {linkName}
            </Link>
          ) : null}
        </Stack>
        <IconButton
          sx={[
            { color: '#FFFFFF', fontWeight: 300 },
            mobile ? { marginLeft: '8px' } : null,
          ]}
          onClick={() => {
            updateNotificationStatus({ notificationId });
          }}
        >
          {isNotificationLoading ? (
            <CircularProgress
              size={20}
              sx={{
                color: 'var(--color-white)',
              }}
            />
          ) : (
            <CloseIcon />
          )}
        </IconButton>
      </Stack>
    </Stack>
  );
};
TopNotification.propTypes = {
  notificationId: PropTypes.string,
  startIcon: PropTypes.node,
  message: PropTypes.string,
  linkUrl: PropTypes.node,
  linkName: PropTypes.string,
};
TopNotification.defaultProps = {
  notificationId: '',
  startIcon: null,
  message: '',
  linkUrl: null,
  linkName: '',
};
export default TopNotification;
